import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AutoLogout from "./AutoLogout.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import { adminRoutes, publicRoutes } from "./routes";
import ProtectedOutlet,  { PublicOutlet  , ProtectedRoute} from "./ProtectedRoutes";
import CheckPageTitle from "./Common/pageTitle/CheckPageTitle";

//socket configuration
import { SocketProvider } from "./socket/SocketContext";
import { SOCKET_URL } from "./environment";
import PageNotFound from "./Common/Component/PageNotFound.js";
import Layout from "./Layout/Layout.js";

function App() {
  return (
    <>
      <ToastContainer />
      <SocketProvider socketUrl={SOCKET_URL}>
      
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AutoLogout /> {/* Move inside BrowserRouter to fix useNavigate() error */}
        <CheckPageTitle />
        <Routes>
          <Route element={<PublicOutlet />}>
            {publicRoutes.map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  element={route.component}
                />
              );
            })}
          </Route>

          <Route path="/admin" element={<ProtectedRoute />}>
          
            {adminRoutes.map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  element={<route.layout>{route.component}</route.layout>}
                />
              );
            })}



          </Route>

          <Route path="/doctor" element={<ProtectedRoute />}>
          
          {adminRoutes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                element={<route.layout>{route.component}</route.layout>}
              />
            );
          })}
        
        
        
        </Route>
         
        <Route path="unauthorized" element={  <PageNotFound />} />
        </Routes>
      </BrowserRouter> 
      
      </SocketProvider>
    </>
  );
}

export default App;
